/**
 * Idle Timeout Configuration
 * 
 * These values can be customized based on compliance requirements.
 * Default values:
 * - Idle timeout: 30 minutes
 * - Warning time: 2 minutes before timeout
 */

export const IDLE_TIMEOUT_CONFIG = {
  /** Idle timeout duration in milliseconds */
  // For production: Use 30 minutes (30 * 60 * 1000)
  TIMEOUT_MS: 30 * 60 * 1000, // 30 minutes (PRODUCTION)
  
  /** Warning time before timeout in milliseconds */
  // For production: Use 2 minutes (2 * 60 * 1000)
  WARNING_MS: 2 * 60 * 1000, // 2 minutes (PRODUCTION)
} as const;
